import {
  Button,
  Input,
  Row,
  Space,
  Col,
  Form,
  Popconfirm,
  Select,
  message,
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { createRef } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { CardBody } from "reactstrap";
import { H5, H6 } from "../../../../AbstractElements";
import { GSTAPI, TaxOptionAPI } from "../../../../api";
import { LogEvents, LoggerContext } from "../../../../context/logging";
const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
const Gst = (props) => {
  const { Option } = Select;
  const logger = React.useContext(LoggerContext);

  const taxtTypes = [
    {
      id: 1,
      value: "igst",
      label: "IGST",
    },
    {
      id: 2,
      value: "cgst/sgst",
      label: "CGST/SGST",
    },
    {
      id: 3,
      value: "other",
      label: "other",
    },
  ];
  const formRef = createRef();
  const taxFormRef = createRef();
  const [gstList, setGstList] = useState([]);
  const [taxOptionList, setTaxOptionList] = useState([]);
  const [change, setChange] = useState(false);
  const [changeTax, setChangeTax] = useState(false);
  const { user } = props.settings;
  useEffect(() => {
    fetchGst({
      params: {
        branch: props?.settings?.branch?.id,
      },
    });

    // fetchTaxOptions();
  }, []);
  const fetchGst = ({ params }) => {
    axios.get(`${GSTAPI}`, { params: { ...params } }).then((res) => {
      setGstList(res.data);
      console.log("res.data ", res.data);
    });
  };
  const fetchTaxOptions = () => {
    axios.get(`${TaxOptionAPI}`).then((res) => {
      setTaxOptionList(res.data);
    });
  };
  const addGst = () => {
    logger.log(LogEvents.addOrganizationGstDetail, {});

    const updateValues = formRef.current.getFieldsValue();
    // console.log(updateValues, "ssss");
    const value = new FormData();
    value.append("label", updateValues.name ? updateValues.name : "");
    value.append("city", updateValues.city ? updateValues.city : "");
    value.append("pincode", updateValues.pincode ? updateValues.pincode : "");
    value.append("address", updateValues.address ? updateValues.address : "");
    value.append("gst_no", updateValues.gst_no ? updateValues.gst_no : "");
    value.append("branch", props?.settings?.branch?.id);
    value.append("contact", updateValues.contact ?? "");
    value.append("email", updateValues.email ?? "");
    value.append("pan_no", updateValues.pan_no ?? "");
    axios
      .post(`${GSTAPI}`, value)
      .then((res) => {
        toast.success("Added Successfully!");
        formRef.current.resetFields();
        fetchGst({
          params: {
            branch: props?.settings?.branch?.id,
          },
        });
      })
      .catch((res) => {
        toast.error("Something Went Wrong!");
      });
  };
  const deleteGst = (e, id) => {
    e.preventDefault();
    axios
      .delete(`${GSTAPI}${id}/`)
      .then((res) => {
        toast.success("GST deleted successfully!");
        fetchGst({
          params: {
            branch: props?.settings?.branch?.id,
          },
        });
      })
      .catch((res) => {
        toast.error("Something went wrong!");
      });
  };
  const changeValue = (value, name, data) => {
    setChange(true);
    var array = gstList;
    for (var i = 0; i < array?.length; i++) {
      if (array[i]?.id === data?.id) {
        array[i][name] = value;
      }
    }
    setGstList(array);
  };
  const saveChanges = (e) => {
    e.preventDefault();
    if (gstList?.filter((each) => each?.label === "").length > 0) {
      toast.error("Label Field cannot be empty!");
      return;
    } else {
      var array = gstList;
      var j = 0;
      for (var i = 0; i < array?.length; i++) {
        const value = new FormData();
        value.append("label", array[i]?.label);
        value.append("city", array[i]?.city);
        value.append("pincode", array[i]?.pincode);
        value.append("address", array[i]?.address);
        value.append("gst_no", array[i]?.gst_no);
        value.append("contact", array[i].contact);
        value.append("email", array[i].email);
        value.append("pan_no", array[i].pan_no);
        axios
          .put(`${GSTAPI}${array[i]?.id}/`, value)
          .then((res) => {
            j += 1;
          })
          .catch((res) => {
            toast.error("Something Went Wrong!");
          });
      }
      toast.success("Changes Saved!");
      setChange(false);
    }
  };
  const addTax = () => {
    const updateValues = taxFormRef.current.getFieldsValue();
    if (updateValues.percentage > 28) {
      message.error("Maximum percentage can be 28");
      return;
    }
    const value = new FormData();
    value.append("label", updateValues.label ? updateValues.label : "");
    value.append(
      "percentage",
      updateValues.percentage ? updateValues.percentage : ""
    );
    value.append(
      "tax_type",
      updateValues.tax_type ? updateValues.tax_type : ""
    );
    value.append("organisation", user?.organisation?.organisation_id);
    axios
      .post(`${TaxOptionAPI}`, value)
      .then((res) => {
        toast.success("Added Successfully!");
        taxFormRef.current.resetFields();
        fetchTaxOptions();
      })
      .catch((res) => {
        toast.error("Something Went Wrong!");
      });
  };
  const deleteTax = (e, id) => {
    e.preventDefault();
    axios
      .delete(`${TaxOptionAPI}${id}/`)
      .then((res) => {
        toast.success("Tax Option deleted successfully!");
        fetchTaxOptions();
      })
      .catch((res) => {
        toast.error("Something went wrong!");
      });
  };
  const changeValueTax = (value, name, data) => {
    // console.log(value,name,data,"ssgdj")
    setChangeTax(true);
    var array = taxOptionList;
    for (var i = 0; i < array?.length; i++) {
      if (array[i]?.id === data?.id) {
        array[i][name] = value;
      }
    }
    setTaxOptionList(array);
  };
  const saveChangesTax = (e) => {
    e.preventDefault();
    if (taxOptionList?.filter((each) => each?.label === "").length > 0) {
      toast.error("Label Field cannot be empty!");
      return;
    } else {
      var array = taxOptionList;
      var j = 0;
      for (var i = 0; i < array?.length; i++) {
        const value = new FormData();
        value.append("label", array[i]?.label);
        value.append("percentage", array[i]?.percentage);
        value.append("tax_type", array[i]?.tax_type);
        axios
          .put(`${TaxOptionAPI}${array[i]?.id}/`, value)
          .then((res) => {
            j += 1;
          })
          .catch((res) => {
            toast.error("Something Went Wrong!");
          });
      }
      toast.success("Changes Saved!");
      setChange(false);
    }
  };
  return (
    <React.Fragment>
      {/* GST */}
      <CardBody>
        {gstList?.length > 0 && (
          <div className="d-flex justify-content-between">
            <H5>Existing GST Options</H5>
            <Button
              disabled={!change}
              onClick={(e) => {
                saveChanges(e);
              }}
            >
              Save Changes
            </Button>
          </div>
        )}

        {gstList.length !== 0 ? (
          <Row gutter={4}>
            <Col sm={2}>
              <H6>Label</H6>
            </Col>
            <Col sm={2}>
              <H6>City</H6>
            </Col>
            <Col sm={2}>
              <H6>Pincode</H6>
            </Col>
            <Col sm={2}>
              <H6>Contact</H6>
            </Col>
            <Col sm={2}>
              <H6>Email</H6>
            </Col>
            <Col sm={5}>
              <H6>Address</H6>
            </Col>
            <Col sm={3}>
              <H6>Gst</H6>
            </Col>
            <Col sm={3}>
              <H6>Pan</H6>
            </Col>
          </Row>
        ) : null}

        <div className="my-2">
          {gstList?.map((each, ind) => (
            <div key={each?.id} className="mt-3">
              <Row gutter={4}>
                <Col sm={2}>
                  <TextArea
                    className="non-resizable"
                    name="label"
                    placeholder="Label"
                    defaultValue={each?.label}
                    onChange={(e) => {
                      changeValue(e.target.value, e.target.name, each);
                    }}
                  />
                </Col>
                <Col sm={2}>
                  <TextArea
                    name="city"
                    placeholder="City"
                    defaultValue={each?.city}
                    onChange={(e) => {
                      changeValue(e.target.value, e.target.name, each);
                    }}
                  />
                </Col>
                <Col sm={2}>
                  <Input
                    name="pincode"
                    placeholder="Pincode"
                    defaultValue={each?.pincode}
                    onChange={(e) => {
                      changeValue(e.target.value, e.target.name, each);
                    }}
                  />
                </Col>
                <Col sm={2}>
                  <TextArea
                    name="contact"
                    placeholder="Contact"
                    defaultValue={each?.contact}
                    onChange={(e) => {
                      changeValue(e.target.value, e.target.name, each);
                    }}
                  />
                </Col>
                <Col sm={2}>
                  <TextArea
                    name="email"
                    placeholder="Email"
                    defaultValue={each?.email}
                    onChange={(e) => {
                      changeValue(e.target.value, e.target.name, each);
                    }}
                  />
                </Col>
                <Col sm={5}>
                  <TextArea
                    name="address"
                    placeholder="Address"
                    defaultValue={each?.address}
                    onChange={(e) => {
                      changeValue(e.target.value, e.target.name, each);
                    }}
                  />
                </Col>
                <Col sm={3}>
                  <TextArea
                    name="gst"
                    placeholder="GST"
                    defaultValue={each?.gst_no}
                    onChange={(e) => {
                      changeValue(e.target.value, e.target.name, each);
                    }}
                  />
                </Col>
                <Col sm={3}>
                  <TextArea
                    name="pan_no"
                    placeholder="Pan"
                    defaultValue={each?.pan_no}
                    onChange={(e) => {
                      changeValue(e.target.value, e.target.name, each);
                    }}
                  />
                </Col>
                <Col sm={2}>
                  <Space>
                    <Popconfirm
                      title="Are you sure to delete?"
                      okText="Yes"
                      cancelText="Cancel"
                      onConfirm={(e) => {
                        deleteGst(e, each?.id);
                      }}
                    >
                      <Button danger>Delete</Button>
                    </Popconfirm>
                  </Space>
                </Col>
              </Row>
            </div>
          ))}
        </div>
        <div className="mt-4">
          <H5>Add New GST Option</H5>
        </div>
        <Form className="mt-4" ref={formRef} id="gstForm" onFinish={addGst}>
          <Row gutter={24}>
            <Col sm={2}>
              <Form.Item
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Label is required",
                  },
                ]}
              >
                <Input placeholder="Label" />
              </Form.Item>
            </Col>
            <Col sm={2}>
              <Form.Item
                name="city"
                rules={[
                  {
                    required: true,
                    message: "City is required",
                  },
                ]}
              >
                <Input placeholder="City" />
              </Form.Item>
            </Col>
            <Col sm={2}>
              <Form.Item
                name="pincode"
                rules={[
                  {
                    required: true,
                    pattern: /^[0-9]{6}$/,
                    message: "Enter a valid six digit pin code",
                  },
                ]}
              >
                <Input placeholder="Pincode" />
              </Form.Item>
            </Col>
            <Col sm={2}>
              <Form.Item
                name="contact"
                rules={[
                  {
                    required: true,
                    pattern: /^[0-9]{10}$/,
                    message: "Enter a valid six 10 number",
                  },
                ]}
              >
                <Input placeholder="Contact" />
              </Form.Item>
            </Col>
            <Col sm={2}>
              <Form.Item name="email">
                <TextArea placeholder="Email" />
              </Form.Item>
            </Col>
            <Col sm={5}>
              <Form.Item name="address">
                <TextArea placeholder="Address" />
              </Form.Item>
            </Col>
            <Col sm={3}>
              <Form.Item
                name="gst_no"
                rules={[
                  {
                    required: true,
                    pattern:
                      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                    message: "Enter a valid GST number",
                  },
                ]}
              >
                <Input placeholder="GST" />
              </Form.Item>
            </Col>
            <Col sm={3}>
              <Form.Item name="pan_no">
                <Input placeholder="Pan" />
              </Form.Item>
            </Col>
            <Col sm={5}>
              <Space>
                <Button form="gstForm" htmlType="submit">
                  Add
                </Button>
                <Button form="gstForm" htmlType="reset" danger>
                  Clear
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>
        <hr />
      </CardBody>
      {/* GST */}

      {/* TAX */}
      {/*<CardBody>
        <div className="d-flex justify-content-between">
          <H5>Existing Tax Options</H5>
          <Button
            disabled={!changeTax}
            onClick={(e) => {
              saveChangesTax(e);
            }}
          >
            Save Changes
          </Button>
        </div>
        <div className="my-2">
          {taxOptionList?.map((each, ind) => (
            <div key={each?.id} className="mt-3">
              <Row gutter={24}>
                <Col sm={8}>
                  <Input
                    name="label"
                    defaultValue={each?.label}
                    placeholder="Label"
                    onChange={(e) => {
                      changeValueTax(e.target.value, e.target.name, each);
                    }}
                  />
                </Col>
                <Col sm={6}>
                  <InputNumber
                    className="w-100"
                    name="percentage"
                    placeholder="Percentage"
                    defaultValue={each?.percentage}
                    onChange={(e) => {
                      changeValueTax(e, "percentage", each);
                    }}
                  />
                </Col>
                <Col sm={5}>
                  <Select
                    name="tax_type"
                    defaultValue={each?.tax_type}
                    placeholder="Select Tax Type"
                    onChange={(e) => {
                      changeValueTax(e, "tax_type", each);
                    }}
                  >
                    {taxTypeOptions}
                  </Select>
                </Col>
                <Col sm={4}>
                  <Space>
                    <Popconfirm
                      title="Are you sure to delete?"
                      okText="Yes"
                      cancelText="Cancel"
                      onConfirm={(e) => {
                        deleteTax(e, each?.id);
                      }}
                    >
                      <Button danger>Delete</Button>
                    </Popconfirm>
                  </Space>
                </Col>
              </Row>
            </div>
          ))}
        </div>
        <div className="mt-4">
          <H5>Add New Tax Option</H5>
        </div>
        <Form className="mt-4" ref={taxFormRef} id="taxForm" onFinish={addTax}>
          <Row gutter={24}>
            <Col sm={8}>
              <Form.Item
                name="label"
                rules={[
                  {
                    required: true,
                    message: "Label is required",
                  },
                ]}
              >
                <Input placeholder="Label" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="percentage"
                rules={[
                  {
                    required: true,
                    message: "Percentage is required",
                  },
                ]}
              >
                <InputNumber
                  className="w-100"
                  min={1}
                  max={28}
                  placeholder="Percentage"
                />
              </Form.Item>
            </Col>
            <Col sm={5}>
              <Form.Item name="tax_type">
                <Select placeholder="Select Tax Type">{taxTypeOptions}</Select>
              </Form.Item>
            </Col>
            <Col sm={4}>
              <Space>
                <Button form="taxForm" htmlType="submit">
                  Add
                </Button>
                <Button form="taxForm" htmlType="reset" danger>
                  Clear
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>
              </CardBody>*/}
      {/* TAX */}
    </React.Fragment>
  );
};

export default connect(mapStateToProps)(Gst);
